import React, { createContext, ReactNode } from 'react';

import MetricsService from '../../common/services/MetricsService';

interface PublicMenuContextProps {
  onSendingMetricEvent: (method: string) => void;
}

const PublicMenuContext = createContext<PublicMenuContextProps>({} as PublicMenuContextProps);

type PublicMenuProviderProps = {
  children: ReactNode;
  metricsService: MetricsService;
};

export const PublicMenuProvider: React.FC<PublicMenuProviderProps> = ({
  children,
  metricsService,
}: PublicMenuProviderProps) => {
  const onSendingMetricEvent = (method: string) => {
    (metricsService as any)[method]();
  };

  return (
    <PublicMenuContext.Provider value={{ onSendingMetricEvent }}>
      {children}
    </PublicMenuContext.Provider>
  );
};

export default PublicMenuContext;
